export const SpecialTiles = 'special-tiles';
export const Tiles = 'tiles';

export enum MatomoCategory {
  Tiles = 'Tiles',
  Dashboard = 'Dashboard',
  Theme = 'Theme'
}

export enum MatomoAction {
  NewTileAdded = 'New Tile Added',
  TileChanged = 'Tile Changed',

  TilesRearranged = 'Tiles Rearranged',
  ThemeChanged = 'Theme Changed',
  Export = 'Export',
  Import = 'Import',
  Reset = 'Reset',
  ImageUpload = 'Image Upload'
}
